import { createStore } from 'vuex'

export default createStore({
  state: {
    brandConfig: undefined,
    msisdn: undefined
  },
  getters: {
  },
  mutations: {
    setBrandConfig(state, brandConfig) {
      state.brandConfig = brandConfig
    },
    setMsisdn(state, msisdn) {
      state.msisdn = msisdn
    }
  },
  actions: {
  },
  modules: {
  }
})
